function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
export var pcsMenu = new ( /*#__PURE__*/function () {
  function PcsMenu() {
    var _this = this;
    _classCallCheck(this, PcsMenu);
    vent.on('APP:READY', function (_) {
      _this.init();
    });
  }
  _createClass(PcsMenu, [{
    key: "init",
    value: function init() {
      // vent.on('PCS:OPEN_MENU', this.onOpenMenu.bind(this));
      // vent.on('PCS:CLOSE_MENU', this.onCloseMenu.bind(this));
      // $(document).on('click', '[aria-controls="main-menu"]', this.onControlMenu.bind(this));
    }
  }, {
    key: "getFormElements",
    value: function getFormElements($elt) {
      var $form = $elt.closest('.pcs-page-form');
      var $fields = $form.find('.pcs-form-values__fields');
      return {
        $form: $form,
        $fields: $fields
      };
    }
  }, {
    key: "onControlMenu",
    value: function onControlMenu(e) {
      if ($(e.target).attr('aria-expanded') === 'true') {
        vent.publish('PCS:CLOSE_MENU');
      } else {
        vent.publish('PCS:OPEN_MENU');
      }
    }
  }, {
    key: "onOpenMenu",
    value: function onOpenMenu(e) {
      $('#main-menu').attr('aria-hidden', 'false');
      $('[aria-controls="main-menu"]').attr('aria-expanded', 'true');
    }
  }, {
    key: "onCloseMenu",
    value: function onCloseMenu(e) {
      $('#main-menu').attr('aria-hidden', 'true');
      $('[aria-controls="main-menu"]').attr('aria-expanded', 'false');
    }
  }]);
  return PcsMenu;
}())();